var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.showComponent)?_c('div',{key:_vm.componentRefresh,staticClass:"w-100",attrs:{"title":_vm.qaAble ? _vm.showIfHasPermission?.toString() : null}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }